import { app } from '../../../bootstrap/core';
import { iframeFixComponent } from './iframeFix.component';

app.component('iframeFix', iframeFixComponent);
